export const LIMONADE_EYE_REPORT_SCHEMA = 'limonade-eye-report/v1';
export const LIMONADE_MOTIONLINK_SCHEMA = 'limonade-motionlink/v1';
//# sourceMappingURL=types.js.map